(function() {
    window.addEventListener("load", function() {
        improveAnchorFunctionality();
        printMyWebPageLinks();
    });

    function improveAnchorFunctionality() {
        let url = window.location.href;
        if (url.indexOf("#") !== -1) {
            let anchor = url.substring(url.indexOf("#") + 1),
                element = document.getElementById(anchor);
            if (element) {
                setTimeout(function () {
                    element.scrollIntoView();
                }, 0);

            }
        }
    }

    function printMyWebPageLinks(){  
        const printLinks = document.querySelectorAll('.__js-print-page-link'); 
        printLinks.forEach(link => {
            link.addEventListener('click', function(e) {
                console.log('link');
                e.preventDefault();
                window.print();
            });
        }); 
    } 
})();



class QuickViewTriggerInitializer extends HTMLElement {
  constructor() {
    super();

    const wrapper = this.closest('.quick-view-snippet__wrapper');
    const parentSelector = this.dataset.parent;
    const triggerSelector = this.dataset.trigger;

    if (!wrapper || !parentSelector || !triggerSelector) return;

    const parent = this.closest(parentSelector);

    if (!parent) return;

    const triggers = parent.querySelectorAll(triggerSelector);
    const drawer = wrapper.querySelector('quick-view-drawer');
    const sliderElement = this.closest('.keen-slider');

    if (sliderElement) {
      const categoryCarousel = sliderElement.closest(
        '[data-kiss-category-carousel]'
      );

      if (categoryCarousel) {
        categoryCarousel.appendChild(wrapper);
      } else {
        sliderElement.appendChild(wrapper);
      }
    }

    triggers.forEach((trigger) => {
      if (trigger.dataset.quickViewInitialized === 'true') return;

      trigger.dataset.quickViewInitialized = 'true';

      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        const summary = drawer?.querySelector('summary');

        if (!summary) return;

        const savedScrollX = window.scrollX;
        const savedScrollY = window.scrollY;

        summary.click();

        requestAnimationFrame(() => {
          window.scrollTo({
            left: savedScrollX,
            top: savedScrollY,
            behavior: 'auto'
          });

          requestAnimationFrame(() => {
            window.scrollTo({
              left: savedScrollX,
              top: savedScrollY,
              behavior: 'auto'
            });
          });
        });
      });
    });

  } // closes constructor()
} // closes QuickViewTriggerInitializer

if (!customElements.get('quick-view-trigger')) {
  customElements.define(
    'quick-view-trigger',
    QuickViewTriggerInitializer
  );
}


(function () {
  window.addEventListener("DOMContentLoaded", () => {
    const termsEl = document.querySelector("shopify-payment-terms");
    if (!termsEl) return; // bail if it's not there

    const inject = () => {
      // optional chaining ensures no errors if shadowRoot is missing
      const shadow = termsEl.shadowRoot;
      if (shadow && !shadow.querySelector("#custom-font-style")) {
        const style = document.createElement("style");
        style.id = "custom-font-style";
        style.textContent = `.font-system { font-family: arial, sans-serif !important; }`;
        shadow.appendChild(style);
      }
    };

    // run immediately
    inject();

    // watch for re-renders
    const observer = new MutationObserver(() => {
      inject();
      if (termsEl.shadowRoot?.querySelector("#custom-font-style")) {
        observer.disconnect(); // stop once injected successfully
      }
    });

    observer.observe(termsEl, { childList: true, subtree: true });
  });
})();


(function () {
  window.addEventListener("DOMContentLoaded", () => {
    const body = document.body;
    const openDrawerTriggers = [
      ".cart-drawer-container",
      ".menu-drawer-container",
      ".store-swticher-nav-btn"
    ];

    
    const closeDrawerTriggers = [
      ".drawer-close-button",  
      ".store-swticher-close-btn",
      ".store-switcher-nav" 
    ];

    openDrawerTriggers.forEach(function (selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.addEventListener("click", () => {  
            console.log("Open");
            body.classList.add("gorgias-zfix"); 
        });
      }
    });

    closeDrawerTriggers.forEach(function (selector) {
      const el = document.querySelector(selector);
      if (el) {
        el.addEventListener("click", () => {  
            console.log("Close");
            if(body.classList.contains("gorgias-zfix")){
                 body.classList.remove("gorgias-zfix");
            } 
        });
      }
    });


  });
})();